export const taxRate = 0.05;
export const discountPercent = 0.05;
